import React from "react";
import { useI18n } from "@/contexts/I18nContext";

const SOCIAL_LINKS = [
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/hemaia-health/",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/hemaiahealth",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61588999536980",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@hemaiahealth",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.77a4.85 4.85 0 0 1-1.01-.08z" />
      </svg>
    ),
  },
];

export default function Footer() {
  const { lang } = useI18n();
  const isRTL = lang === "ar";

  return (
    <footer className="bg-foreground text-white py-16" dir={isRTL ? "rtl" : "ltr"}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src="/hemaia_logo_light.svg" alt="Hemaia" className="h-10 mb-4" />
            <p className="text-sm text-white/60 max-w-sm leading-relaxed">
              {lang === "ar"
                ? "حماية هي منصة ولاء الرعاية الصحية في مصر. وفّر من 20% إلى 60% على زياراتك الطبية مع شبكة واسعة من الأطباء والعيادات المعتمدة."
                : "Hemaia is Egypt's healthcare loyalty network. Save 20–60% on every medical visit with our growing network of verified clinics and hospitals."}
            </p>
            <div className="flex gap-4 mt-6">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="text-white/50 hover:text-white transition-colors"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">{lang === "ar" ? "روابط سريعة" : "Quick Links"}</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><a href="/signup" className="hover:text-white transition-colors">{lang === "ar" ? "انضم الآن" : "Join Now"}</a></li>
              <li><a href="/login" className="hover:text-white transition-colors">{lang === "ar" ? "تسجيل دخول" : "Sign In"}</a></li>
              <li><a href="/about" className="hover:text-white transition-colors">{lang === "ar" ? "من نحن" : "About Us"}</a></li>
              <li><a href="/faq" className="hover:text-white transition-colors">{lang === "ar" ? "الأسئلة الشائعة" : "FAQ"}</a></li>
              <li><a href="/contact" className="hover:text-white transition-colors">{lang === "ar" ? "تواصل معنا" : "Contact"}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">{lang === "ar" ? "تواصل معنا" : "Contact"}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li><a href="mailto:hello@hemaia.net" className="hover:text-white transition-colors">hello@hemaia.net</a></li>
              <li>
                {lang === "ar"
                  ? <span className="leading-relaxed">شارع الاسراء ٤١ (ميدان لبنان)<br />برج 26 يوليو، الدور 9، مكتب 903<br />المهندسين، الجيزة، مصر</span>
                  : <span className="leading-relaxed">41 Al-Israa Street (off Lebanon Square)<br />26th of July Tower, 9th Floor, Office 903<br />Mohandessin, Giza, Egypt</span>
                }
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 text-center text-xs text-white/40">
          {lang === "ar" ? "© 2026 حماية. جميع الحقوق محفوظة." : "© 2026 Hemaia. All rights reserved."}
        </div>
      </div>
    </footer>
  );
}
